import React, { useRef, useEffect } from 'react';
import { func, node, string } from 'prop-types';
import classNames from 'classnames';

import css from './OutsideClickHandler.module.css';

const OutsideClickHandler = props => {
  const { rootClassName = null, className = null, children, onOutsideClick } = props;
  const nodeRef = useRef(null);

  useEffect(() => {
    const handleClick = event => {
      if (nodeRef.current && !nodeRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };
    document.addEventListener('mousedown', handleClick, false);
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
    };
  }, [onOutsideClick]);

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} ref={nodeRef}>
      {children}
    </div>
  );
};

OutsideClickHandler.propTypes = {
  rootClassName: string,
  className: string,
  onOutsideClick: func.isRequired,
  children: node.isRequired,
};

export default OutsideClickHandler;
